import { HorizontalSpotAndGreeksFieldComponent } from './HorizontalSpotAndGreeksField';
import { connectMultipleUnderlingComponent } from './SpotAndGreekField.connect';
import { VerticalSpotAndGreeksFieldComponent } from './VerticalSpotAndGreeksField';

export const VerticalSpotAndGreeksField = connectMultipleUnderlingComponent(VerticalSpotAndGreeksFieldComponent);
export const HorizontalSpotAndGreeksField = connectMultipleUnderlingComponent(HorizontalSpotAndGreeksFieldComponent);
